import {Injectable, signal} from '@angular/core';
import {NonNullableFormBuilder} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import moment from 'moment';
import {AdxSbReconciliationFilterForm, AdxSbReconciliationFilterModel} from '../model/adx-sb-reconciliation-filter-model';

/**
 * Holds the single page-level filter for the ADX SB-vs-HTTP reconciliation dashboard.
 * The navbar flips <see cref="toggleModal"/> to open the filter modal; the modal calls
 * setFilters(); every grid's GridGetService reads filtersValue(). Defaults to the current
 * ISO-week Monday → today, Issue date basis, only-mismatches on.
 */
@Injectable({
  providedIn: 'root'
})
export class AdxSbReconciliationFilterService {
  public readonly toggleModal = signal(false);

  public readonly filtersValue = signal<AdxSbReconciliationFilterModel>(this.buildDefaultFilters());

  private readonly filters$ = new BehaviorSubject<AdxSbReconciliationFilterModel>(this.filtersValue());

  public get form(): AdxSbReconciliationFilterForm {
    return this.formBuilder.group({
      From: [null as Date | null],
      To: [null as Date | null],
      Day: [null as Date | null],
      RecordLocator: [null as string | null],
      DateBasis: ['Issue' as string | null],
      OnlyMismatches: [true],
    });
  }

  constructor(private readonly formBuilder: NonNullableFormBuilder) {}

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: AdxSbReconciliationFilterModel) {
    this.filters$.next(value);
    this.filtersValue.set(value);
  }

  public buildDefaultFilters(): AdxSbReconciliationFilterModel {
    return {
      From: moment().startOf('isoWeek').toDate(),
      To: null,
      Day: null,
      RecordLocator: null,
      DateBasis: 'Issue',
      OnlyMismatches: true,
      ReloadGrid: false,
    };
  }
}
